function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { OverlayScrollbarsComponent } from '@isyc-react/design/scrollbar';
import clsx from 'clsx';
import '@isyc-react/design/main';
import "./table.style.scss";
const defaultTableResponsiveClassNames = {
  table: '',
  tableContainer: 'react-table-responsive-container'
};
export const TableResponsive = props => {
  const {
    instance: {
      getTableProps
    },
    className = defaultTableResponsiveClassNames,
    children,
    summary = ''
  } = props;
  const {
    table = defaultTableResponsiveClassNames.table,
    tableContainer = defaultTableResponsiveClassNames.tableContainer
  } = className;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(tableContainer)
  }, /*#__PURE__*/React.createElement(OverlayScrollbarsComponent, null, /*#__PURE__*/React.createElement("table", _extends({
    className: clsx(table)
  }, getTableProps(), {
    summary: summary
  }), /*#__PURE__*/React.createElement("caption", null), children)));
};